import { EnvironmentConfig } from '@emi/shared/models';
import { LogLevel } from 'angular-auth-oidc-client';

export const environment: EnvironmentConfig = {
    production: false,
    apiBaseUrl: 'https://api.dev.euromonitor.com/via',
    passportHelpServiceUrl: 'https://api.passport.dev.euromonitor.com/passport-help-service/api/v1',
    helpServiceUrl: 'https://api.dev.euromonitor.com/via',
    redirectFeedback: true,
    subscriberServiceUrl: 'https://subscriber-subscription.qa.euromonitor.com',
    imagesUrl: 'https://dvviaimagewesa.blob.core.windows.net/images/',
    authSettings: {
        authority: 'https://login.qa.euromonitor.com',
        redirectUrl: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        clientId: 'via-shell-angular',
        scope: 'openid profile subscriber Euromonitor.Subscribers.SubscriptionService offline_access EMI.Help',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 20,
        logLevel: LogLevel.Error,
        customParamsRefreshTokenRequest: {
            scope: 'openid profile',
        },
        customParamsAuthRequest: {
            acr_values:
                new URL(window.location.href).searchParams.get('stoken') != null
                    ? 'idp:Azure stoken:' + new URL(window.location.href).searchParams.get('stoken')
                    : '',
        },
    },
};
